import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import ReactPixel from 'react-facebook-pixel';
ReactPixel.init('931401796468747');
ReactPixel.pageView();
render(<App data-id="element-183" />, document.getElementById('root'));